import * as React from 'react';
import { GroupServiceGetResponse } from '../../../services/api';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import ModalButtons from '../../ui/modals/ModalButtons';
import FileUploader from '../../uploads/FileUploader';
import { APIStatus } from '../../../utils/types';
import { Message } from 'primereact/message';
import { submitHighRiskLockRequest } from '../../../store/group';

export default function HighRiskRequestForm({ group, onComplete }: { group: GroupServiceGetResponse, onComplete: () => void }) {
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [submissionState, setSubmissionState] = React.useState<APIStatus|null>(null);
  const [files, setFiles] = React.useState<File[]>([]);
  const [note, setNote] = React.useState<string>('');

  const formIsValid = React.useMemo<boolean>(() => {
    let isValid = true;

    if (!note.length) isValid = false;

    return isValid;
  }, [files, note]);

  async function handleFormSubmit() {
    try {
      setSubmissionState(APIStatus.LOADING);

      await submitHighRiskLockRequest({
        policyNumber: group.policyDetailModel?.policyNumber!,
        file: files[0],
        note,
      });

      hideModal();
      onComplete();
      setSubmissionState(APIStatus.COMPLETE);
    } catch {
      setSubmissionState(APIStatus.ERROR);
    }
  }

  function hideModal() {
    setIsModalVisible(false);
    setNote('');
    setFiles([]);
  }

  return (
    <>
      <Button className="w-full" rounded severity="danger" icon="pi pi-lock" label="lock group from rate relief" onClick={() => setIsModalVisible(true)} />

      <Dialog
        draggable={false}
        header={
          <>  
            <div>Lock rate relief</div>
            <p className="text-base font-normal">Stop relief if too complex and provide decision rationale for Account Management review with supporting documentation and notes.</p>
          </>
        }
        visible={isModalVisible}
        onHide={hideModal}
        footer={
          <ModalButtons
            submitButtonSeverity="danger"
            saveLabel="confirm and lock group"
            isFormValid={formIsValid}
            isLoading={submissionState === APIStatus.LOADING}
            onCancel={() => setIsModalVisible(false)}
            onSave={handleFormSubmit}
          />
        }
      >
        <div className="flex flex-col gap-4">

          <div className="flex flex-col gap-2">
            <FileUploader files={files} onAddFile={(e) => setFiles(e)} />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="notes" className="font-bold">Supporting notes</label>
            <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} id="notes" rows={5} placeholder="Add supporting notes" />
          </div>
        </div>

        {submissionState === APIStatus.ERROR && (
          <div className="flex flex-col mt-4">
            <Message severity="error" text="There was an error submitting your request, please try again" />
          </div>
        )}
      </Dialog>
    </>
  )
}